import VerdantProvider from "@/components/VerdantProvider.jsx";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Button } from "@heroui/react";

import { useMemoizedFn, useUpdateEffect } from "ahooks";
import { memo, type ReactNode } from "react";
import isEqual from "react-fast-compare";
import { ModalProvider } from "react-modal-hook";
import { Drawer } from "vaul";

const SheetWrapperV2 = memo(
	({
		children,
		closeKey,
		overlay,
		onContentRef,
	}: {
		children: ReactNode;
		closeKey?: number;
		overlay?: ReactNode;
		onContentRef?: React.Ref<HTMLDivElement> | undefined;
	}) => {
		const modal = useModal();
		const handleClose = useMemoizedFn(() => {
			modal.hide();
		});
		useUpdateEffect(() => {
			handleClose();
			setTimeout(() => {
				modal.remove();
			}, 300);
		}, [closeKey]);

		return (
			<VerdantProvider>
				<ModalProvider>
					<Drawer.Root
						repositionInputs={false}
						onAnimationEnd={() => {
							modal.remove();
						}}
						open={modal.visible}
						onOpenChange={(open) => {
							if (!open) {
								handleClose();
							}
						}}
					>
						<Drawer.Portal>
							<Drawer.Overlay
								className={`fixed inset-0  z-50   ${
									modal.visible ? "bg-black/55" : ""
								}`}
							>
								{modal.visible && overlay}
							</Drawer.Overlay>

							<Drawer.Content
								ref={onContentRef}
								className=" rounded-t-3xl bg-white  h-fit fixed bottom-0 left-0 right-0 outline-none z-50 pt-4"
							>
								<div className="mx-auto w-12 h-1.5 flex-shrink-0 rounded-full bg-gray-300 mb-8" />
								{children}
							</Drawer.Content>
						</Drawer.Portal>
					</Drawer.Root>
				</ModalProvider>
			</VerdantProvider>
		);
	},
	isEqual,
);

export const SheetWrapperHeader = memo(
	({
		title,
		onOk,
		hideOk,
		align,
		extra,
		okText,
		sticky,
	}: {
		title: string;
		onOk?: () => void;
		align?: string;
		hideOk?: boolean;
		extra?: ReactNode;
		okText?: string;
		sticky?: boolean;
	}) => {
		return (
			<Drawer.Title
				className={`flex items-center bg-white   px-4 pb-2 relative font-semibold text-gray-800  ${
					align === "left" ? "text-2xl" : "text-center text-lg justify-center"
				} ${sticky ? " sticky top-0" : ""}`}
			>
				{title}
				<div className="absolute right-4">
					{!hideOk && (
						<Button
							className="  font-bold"
							size="sm"
							radius="full"
							color="primary"
							type="submit"
							onPress={onOk}
						>
							{okText || "完成"}
						</Button>
					)}
					{extra}
				</div>
			</Drawer.Title>
		);
	},
	isEqual,
);
export default SheetWrapperV2;
